import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';

import '../../../../assets/styles/finalReport/templateCard.css';
import DefaultReportTemplateDialog from './templateDialogs/defaultReportDialog';

const DefaultCard = () => {
  const [openDialog, setOpenDialog] = useState(false);

  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };
  const raisedShadowStyle =
    '0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12);';

  return (
    <>
      <Card
        sx={{
          width: '263px',
          '&:hover': {
            boxShadow: raisedShadowStyle,
            '& > .actions': {
              visibility: 'visible',
            },
          },
        }}
      >
        <CardContent
          sx={{
            height: '108px',
          }}
        >
          <Typography fontSize={14} color='#878787'>
            <FormattedMessage defaultMessage='Default' />
          </Typography>
          <Typography fontSize={20} marginTop='12px'>
            <FormattedMessage defaultMessage='Final Report' />
          </Typography>
        </CardContent>
        <CardActions
          sx={{
            justifyContent: 'flex-end',
            height: '60px',
          }}
          className='actions'
        >
          <Button variant='text' color='info' onClick={handleOpenDialog}>
            <Typography color='#2449FC' fontSize={14}>
              <FormattedMessage defaultMessage='View' />
            </Typography>
          </Button>
        </CardActions>
      </Card>
      <DefaultReportTemplateDialog
        open={openDialog}
        onClose={handleCloseDialog}
      />
    </>
  );
};

export default DefaultCard;
